import { render, staticRenderFns } from "./SidenavList.vue?vue&type=template&id=361b78cf&scoped=true"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"
import style0 from "./SidenavList.vue?vue&type=style&index=0&id=361b78cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b78cf",
  null
  
)

export default component.exports